<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import installedWindowInsertImg from './images/LP-Snug-Fit-02.jpg';
	import womanReclined from './images/shutterstock_2027059286.jpg';
</script>

<Section backgroundColor="blue" class="[&_p]:text-left">
	<h1>Quiet Comfort Guarantee</h1>
	<p>
		In addition to our <a href="/warranties/residential-lifetime-warranty"
			>Limited Residential Warranty</a
		>
		and <a href="/warranties/snug-fit-guarantee">Snug Fit Guarantee</a>, R
		Value, Inc. doing business as Indow (“Indow”) offers a satisfaction
		guarantee on eligible orders of our Acoustic Grade window inserts in the
		rare case that you are not satisfied with the sound reduction performance of
		your inserts.
	</p>
	<Image src={womanReclined} class="no-bleed" />
</Section>

<Section class="[&_p]:text-left">
	<h2>Eligibility Criteria</h2>
	<p class="w-full">
		To be eligible for our Quiet Comfort Guarantee, each Acoustic Grade window
		insert must:
	</p>
	<ul>
		<li>
			<p>
				Have approximately 4” to 6” of frame depth between the window and the
				placement of the insert. Inserts must be installed at that depth.
			</p>
		</li>
		<li>
			<p>
				Have frames free of obstructions (such as window hardware) that prevent
				an airtight seal.
			</p>
		</li>
		<li>
			<p>
				Follow the measurement and installation instructions provided via our
				visual guides or calls with our Measure Support team.
			</p>
		</li>
		<li>
			<p>
				Install Indow Acoustic Grade inserts in all windows of the affected
				space.
			</p>
		</li>
		<li>
			<p>
				Be part of the first order you place with Indow. Follow-on orders are
				not eligible for the Quiet Comfort Guarantee.
			</p>
		</li>
		<li>
			<p>
				Be installed on a non-commercial property, not used for
				income-generating purposes.
			</p>
		</li>
		<li>
			<p>Claims must be filed within 30 days of installing the inserts.</p>
		</li>
		<li><p>Not be primarily trying to resolve 'deep' or 'bassy' noises.</p></li>
	</ul>
</Section>

<Section
	imageColumn={installedWindowInsertImg}
	loading="lazy"
	columnPosition="left"
	backgroundColor="grey-dark"
	class="
   [&_p]:text-left
   md:[&_p]:max-w-prose
 "
>
	<h2
		class="
    w-full text-left
    md:text-center
  "
	>
		If You’re Not Satisfied With Your Noise Reduction
	</h2>
	<p>
		If you are not satisfied with the sound reduction performance after proper <a
			href="/about-indow/care">receipt and installation</a
		>
		of your Acoustic Grade inserts, you must
		<a href="/claim-submission-customer">file a claim</a> to begin the refund process.
		Our Case Coordinators will work with you to collect relevant information (including
		photos of the installed inserts).
	</p>
	<p>
		Once we have determined that your order meets the criteria for the Quiet
		Comfort Guarantee, Indow will initiate a refund for the difference in cost
		between the Acoustic Grade and Standard Grade inserts. This refund will be
		calculated by factoring in any discounts that were applied at the time of
		your original purchase. Once processed, the refund will be credited directly
		to your original method of payment.
	</p>

	<p>Effective as of 5/29/2025.</p>
</Section>
